module.exports = __webpack_public_path__ + "4e8f122dab99f74e43eb50efe8898c80.png";